import React from 'react';
import { Rocket } from 'lucide-react';

const NoticeCard = () => (
  <div className="rounded-[22px] bg-white border border-[#E7E8EC] p-6 sm:p-7 h-full flex flex-col">
    <div className="flex items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-[#F1EEFE] flex items-center justify-center">
          <Rocket className="w-4 h-4 text-[#6E56E7]" strokeWidth={2.2} />
        </div>
        <div className="text-[15px] font-semibold text-[#111111]">Website im Umbau</div>
      </div>
      <span className="inline-flex items-center h-6 px-2.5 rounded-full bg-[#F6F7F9] border border-[#E7E8EC] text-[11px] font-semibold tracking-[0.14em] text-[#111111] uppercase">
        Seit 15 Jahren
      </span>
    </div>
    <p className="text-[14px] leading-relaxed text-slate-500">
      Unsere neue Website befindet sich aktuell im Umbau. In der Zwischenzeit erreichen Sie uns wie gewohnt telefonisch oder per E-Mail. Wir freuen uns darauf, Ihnen schon bald unseren neuen Auftritt rund um Telekommunikations-Promotion und Vertriebsunterstützung zu präsentieren.
    </p>
    <div className="mt-auto pt-5 flex items-center gap-2 text-[12.5px] text-slate-400">
      <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#6E56E7] animate-pulse" />
      Live in Kürze
    </div>
  </div>
);

export default NoticeCard;
